import React from "react";
import { useTranslation } from "react-i18next";

import SelectSubscriber from "./SelectSubscriber";
import { usePermanentTransferContext } from "@context/PermanentTransferContext";
import { useStepContext } from "@context/shared/StepContext";

type SelectSellerProps = {
  subscribers: any;
};

const SelectSeller: React.FunctionComponent<SelectSellerProps> = ({
  subscribers,
}) => {
  const { t } = useTranslation();
  const { stepHelpers } = useStepContext();
  const { seller, selectSeller, handleCancel, setSelectedExtractionRights } =
    usePermanentTransferContext();

  return (
    <>
      <SelectSubscriber
        title={t("permanent_trade.select_seller")}
        selected={seller}
        onSelect={(value: any) => {
          selectSeller({
            id: value.id,
            name: value.name,
            accountNumber: value.accountNumber,
            walletId: value.walletId,
          });
          setSelectedExtractionRights([]);
        }}
        subscribers={subscribers}
      />
      <footer className="flex gap-4 p-6 border-t border-gray-200">
        <button
          type="button"
          className="btn-outline-primary"
          onClick={stepHelpers.goToPrevStep}
        >
          {t("common.prev_step")}
        </button>
        <button
          type="button"
          className="btn-primary"
          onClick={stepHelpers.goToNextStep}
          disabled={!seller.id}
        >
          {t("common.next_step")}
        </button>
        <button
          type="button"
          className="btn-outline-primary"
          onClick={handleCancel}
        >
          {t("common.cancel")}
        </button>
      </footer>
    </>
  );
};

export default SelectSeller;
